import axios from './index';

class MakerCheckerApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `name=${data.searchTerm}&`;
    }
    if (data.selectedStatusType) {
      query += `status=${data.selectedStatusType}&`;
    }
    if (data.selectedTaskTypeValue) {
      query += `task=${data.selectedTaskTypeValue}&`;
    }

    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }

    return axios.get(`${base}/${query}`);
  };

  static getById = (makerCheckerId) => {
    return axios.get(`${baseForId}/${makerCheckerId}`);
  };

  static Status = (data) => {
    let request = {
      approval_status: data.approve,
      comments: data.comments ? data.comments : 'NA',
    };
    console.log(request);
    return axios.put(`${baseStatus}/${data.makerCheckerId}`, request);
  };

  static StartTransactionVerify = (data) => {
    let query = `start-transaction/${data?.orderId}`;
    return axios.get(`${base}/${query}`);
  };
}

let base = 'dashboard/maker-checker-list';
let baseForId = 'dashboard/maker-checker-details';
let baseStatus = 'dashboard/checker-status';

export default MakerCheckerApi;
